<template>
    <template-list
        :has-add-button="!isCalledControl"
        :page-name="pageName"
        :title-top="titleTop"
        :search-input-placeholder="search.label"
        search-title="Filtrar Clientes"
        add-button-text="Adicionar Cliente"
        add-event="control-accreditation-customer-new"
        search-event="control-customer-search"
        filters-apply-event="called-control-list-filter"
        clear-filters-event="called-control-list-clean-filters"
        menu-card-icon="fal fa-cog"
        @input="loadFilters"
    >
        <template #bradcrumbs>
            <ui-breadcrumbs :container="false" design="full">
                <template #left>
                    <span v-if="isCalledControl">
                        <router-link :to="{ name: 'launch.management' }">
                            <span>Gestão de Lançamentos</span>
                        </router-link>
                        <span> &#8226; Controle</span>
                        <span> &#8226; Controle de Chamado</span>
                    </span>

                    <span v-else>
                        <router-link :to="{ name: 'launch.management' }">
                            <span>Gestão de Lançamentos</span>
                        </router-link>
                        <span> &#8226; Controle</span>
                        <span> &#8226; Controle de Credenciamento</span>
                    </span>	
                </template>
            </ui-breadcrumbs>
        </template>

        <template #filters>
            <form>
                <template v-for="(filter, index) in filters">
                    <ui-select-v2
                        v-if="filter.component === 'select-tags' && !filter.hidden"
                        :key="index"
                        v-model="filter.params.value"
                        :data="filter.options"
                        :label="filter.label"
                        :item-label="filter.itemLabel"
                        :search="filter.searchAble"
                        :multiple="filter.multiple"
                        :return-value="filter.returnValue || 'object'"
                        :group-by="filter.groupBy || ''"
                        :loading="filter.loading"
                        :open-event="filter.openEvent"
                        :disabled="filter.disabled"
                        size="md"
                        @input="call(filter.handler, $event)"
                    />
                </template>
            </form>
        </template>

        <template v-if="isCalledControl" #actions>
            <ui-button
                :loading="loading.call"
                type="submit"
                class="call-customer-button"
                design="md success"
                @click="callCustomer">
                <i class="fal fa-users-class" /> Chamar Cliente
            </ui-button>

            <ui-menu-card icon="fal fa-cog">
                <ui-button type="button" @click="callListHandler">
                    Acessar chamada
                </ui-button>
            </ui-menu-card>
        </template>

        <template #content>
            <ui-table
                :columns="tableColumns"
                :data="tableData"
                :loading="loading.load"
                :select-column-menu="false"
                :tr-component="tableLine"
                not-found-icon="fa fa-file-contract"
                not-found-text="Não foi possível encontrar nenhum cliente neste lançamento"
                name="called-control-list"
            />

            <section class="ui-pagination mt-30">
                <div class="pagination-end">
                    <div v-if="pagination.total_pages > 1" class="text">
                        Página {{ pagination.page }} de {{ pagination.total_pages }}
                    </div>

                    <div v-if="pagination.total_pages > 1" class="control">
                        <button
                            :disabled="!(pagination.total_pages > 1)"
                            type="button"
                            class="md"                            
                            @click="previousPageHandler">
                            <i class="fal fa-angle-left" />
                        </button>

                        <div class="control-list">
                            <button
                                v-for="(page, index) in paginationList"
                                :key="index"
                                :class="{ 'active': isActivePage(page.value) }"
                                class="md"
                                type="button"
                                @click="listPageHandler(page.value)">
                                {{ page.label }}
                            </button>
                        </div>

                        <button
                            :disabled="!(pagination.total_pages > 1)"
                            type="button"
                            class="md"
                            @click="nextPageHandler">
                            <i class="fal fa-angle-right" />
                        </button>
                    </div>
                </div>
            </section>

            <ui-call-customer-modal name="call-customer" />
            <ui-deal-stage-status-modal
                name="launch-control-list-select-stage-status"
                success-event="called-control-list-stage-status-selected"
            />
            <ui-print-customer-accreditation-modal />
        </template>
    </template-list>
</template>

<script>
	import templateList from '@/templates/page-list'
	import { uiButton } from '@/components/ui/buttons'
	import { uiTable, uiBreadcrumbs, uiMenuCard } from '@/components/ui'
	import { uiSelectV2 } from '@/components/ui/form'
	import uiCallCustomerModal from './components/call-customer-modal'
	import { uiDealStageStatusModal } from '@/components/ui-facilita/modals'
	import uiPrintCustomerAccreditationModal from './components/print-customer-accreditation-modal'

	import {
		launchDay,
		funnel,
		team,
		availability,
		deal
	} from '@/services/axios'
	import { storage } from "@/services/storage"

	import helpers from '@/mixins/helpers'

	import { defaultTableColumns, filters } from './data'

	import { mapActions, mapGetters } from 'vuex'

	export default {
		name: 'ui-launch-control-list',

		components: {
			uiButton,
			uiTable,
			uiBreadcrumbs,
			templateList,
			uiCallCustomerModal,
			uiDealStageStatusModal,
			uiSelectV2,
			uiPrintCustomerAccreditationModal,
			uiMenuCard
		},

		mixins: [helpers],

		data() {
			return {
				total: 0,
				loading: {
					load: false,
					call: false
				},
				search: {
					value: '',
					label: 'Buscar cliente por CPF ou ID'
				},
				pagination: {
					total_pages: 0,
					list_size: 5,
					list_index: 0,
					per_page: 25,
					page: 1,
					search: ''
				},
				configurations: {
					manager: {
						label: storage.get('label_manager')
					},
					broker: {
						label: storage.get('label_broker')
					}
				},
				filters: [],
				tableData: [],
				text: '<p>Inclua o script em seu site através de nosso plugin oficial para <strong>WordPress</strong> ou <strong>Código de Incorporação</strong>.</p> <p>Ao incluir o script em seu site o Facilita ficará vigiando todos seus formulários. Quando uma nova submissão é feita, o formulário é detectado e você poderá configurá-lo e ativá-lo de acordo com sua necessidade.</p>',
				btnText: 'Instalar no meu site',
				btnIcon: 'fal fa-cog',
			}
		},

		computed: {
			...mapGetters({
				definitions: 'launchDay/getDefinitions',
				user: 'auth/getUser'
			}),
			/**
			 * Computed property que verifica se a rota atual é do Controle de Chamado
			 */
			isCalledControl() {
				return this.$route.name === 'launch.control.called'
			},
			/**
			 * Computed property que define qual o título a ser mostrado acima do nome da listagem
			 */
			titleTop() {
				return this.definitions && this.definitions.product
					? `${this.definitions.product.name} - Clientes`
					: '-'
			},
			/**
			 * Computed property que define o nome da listagem
			 */
			pageName() {
				return this.isCalledControl ? 'Controle - Chamado' : 'Controle - Credenciamento'
			},
			/**
             * Computed property que retorna uma lista de páginas disponíveis para navegação,
             * bem como opções para avançar ou regredir a lista
             */
            paginationList() {
                let list = [...Array(this.pagination.list_size).keys()].map(i => {
                    const page = (i + 1) + this.pagination.list_index * this.pagination.list_size

                    return { label: page, value: page }
                })
                list = list.filter(item => item.value <= this.pagination.total_pages)

                if (this.pagination.list_index) list.splice(0, 0, { label: '...', value: 'left' })
                if (list[list.length - 1].value < this.pagination.total_pages) {
                    list.splice(list.length, 0, { label: '...', value: 'right' })
                }

                return list
            },
			/**
			 * Computed property que define as colunas a serem mostradas na tabela de acordo com
			 * o controle atual
			 */
			tableColumns() {
				return this.isCalledControl
					? [...defaultTableColumns]
					: Object.values(defaultTableColumns).filter(column => ![
						'Ordem',
						'Credenciamento',
						'Chamada',
						'Reserva de Unidade',
						'Validação de Cliente',
						'Realizar Pagamento',
						'Reservas',
						'Situação'
					].includes(column.title))
			},
			/**
			 * Computed property que define o componente de linha da tabela do controle
			 */
			tableLine() {
				return this.isCalledControl
					? 'launch/control/table-line'
					: 'launch/control/accreditation-table-line'
			}
		},

		mounted() {
			// Define o label do campo de busca quanto no controle de credenciamento
			if (!this.isCalledControl) this.search.label = 'Buscar cliente por ID, nome, e-mail ou CPF'
			// Seta os filtros de acordo com o tipo de controle
			this.filters = this.isCalledControl
				? [...filters]
				: Object.values(filters).filter(filter => ![
					'control',
					'situation',
					'block',
					'unit_id'
				].includes(filter.params.name))

			// Trata o evento de quando um novo negócio/cliente é requerido
			this.$root.$on('take-along-last-row-launchday', () => {
				this.loadData()
			})

			// Trata o evento de quando um negócio/cliente tem sua Etapa/Status alterada
			this.$root.$on('called-control-list-stage-status-selected', (payload) => {
				if (!payload.new || !payload.new.id || !payload.new.funnel_stage_id) return

				const params = {
					funnel_stage_id: payload.new.funnel_stage_id || null,
				}
				if (payload.new.funnel_stage_status_id) {
					params['funnel_stage_status_id'] = payload.new.funnel_stage_status_id
				}

				funnel.updateV2('deal', `${payload.new.id}/move`, params)
					.then(() => {
						this.$root.$emit('close-modal-animation', true, 'Etapa/Status alterada com successo!')
						this.loadData()
					})
					.catch(error => {
						console.log(error)
						this.$root.$emit('close-modal-animation', false, error.data.msg)
					})
			})

			this.$root.$on('control-customer-search', payload => {
				this.search.value = payload
				this.pagination.page = 1
				this.loadData()
			})

			// Realiza uma listagem aplicando os filtros necessários
			this.$root.$on('called-control-list-filter', () => {
				this.$root.$emit('set-filter-selected-active', this.filters)
				this.pagination.page = 1
				this.loadData()
			})

			// Trata o evento que limpa os filtros e refaz a listagem
			this.$root.$on('called-control-list-clean-filters', async() => {
				await this.resetFilters()
				this.pagination.page = 1
				this.loadData()
			})

			// Trata o evento de quando o cadastro de um cliente é solicitado para o Lançamento
			this.$root.$on('control-accreditation-customer-new', () => {
				this.$root.$emit('modal-open-create-deal-modal', {
					type: 'launchday',
					stage: this.definitions.launchday.attributes.saleStage,
					status: this.definitions.launchday.attributes.saleStatus,
					product_id: this.definitions.product.id
				})
			})

			// Trata o evento de quando o cadastro de um cliente/negócio é finalizado
			this.$root.$on('modal-close-create-deal-modal', () => {
				this.pagination.page = 1
				this.loadData()
			})

			// Trata o evento de quando o modal do comprovante de credenciamento é fechado
			this.$root.$on('modal-close-print-customer-accreditation', () => {
				this.loadData()
			})

			this.loadFilters()
			this.setPusher()
			this.loadData()
		},

		beforeDestroy() {
			this.$root.$off('control-accreditation-customer-new')
			this.$root.$off('called-control-list-stage-status-selected')
			this.$root.$off('control-customer-search')
			this.$root.$off('called-control-list-filter')
			this.$root.$off('called-control-list-clean-filters')
			this.$root.$off('modal-close-create-deal-modal')
			this.$root.$off('modal-close-print-customer-accreditation')
			this.removePusher()
		},

		methods: {
			...mapActions('launchDay', [
				'setPusher',
				'removePusher',
			]),
			/**
			 * Chama dinamicamente um handler para tratar o evento do filtro
			 */
			call(handler, event) {
				if (handler) this[handler](event)
			},
			/**
			 * Carrega os dados a serem mostrados nos filtros
			 */
			loadFilters(filters) {
                if (filters) this.filters.map(res => {
                    res.params = filters.find(({ name }) => name == res.params.name)
                })
				for (const filter of this.filters) {
					switch (filter.params.name) {
						case 'block':
							filter.serviceParams.push(this.definitions.product.availability_id)
							break

						case 'team_id':
							/**
							 * Caso o usuário logado seja do tipo gerente ou corretor, seleciona a equipe deste
							 * e desabilita o filtro de equipes
							 */
							if (['manager', 'broker'].includes(this.user.user_group)) {
								if (this.user.user_group === 'manager') {
									filter.params.value = this.user.team ? this.user.team.id : null
								}

								filter.disabled = true
								filter.hidden = true
							}
							break

						case 'manager_id':
							filter.label = this.configurations.manager.label

							/**
							 * Caso o usuário logado seja do tipo gerente ou corretor, carrega o manager_id deste
							 * e desabilita o filtro de gerentes
							 */
							if (['manager', 'broker'].includes(this.user.user_group)) {
								if (this.user.user_group === 'manager') {
									filter.params.value = this.user.manager_id || null
								}

								filter.disabled = true
								filter.hidden = true
							}
							break

						case 'broker_id':
							filter.label = this.configurations.broker.label

							if (this.user.user_group === 'broker') {
								filter.disabled = true
								filter.hidden = true
							}
							break

						case 'owner':
							if (this.user.user_group === 'broker') {
								filter.disabled = true
								filter.hidden = true
							}
							break
					}

					/** Verifica se o filtro possui um handler e se seu valor já foi definido no pré-processamento */
					if (filter.handler && filter.params.value) this.call(filter.handler, filter.params.value)

					if (filter.service && filter.requestOnStart && !filter.alreadyRequested) {
						(() => import('@/services/axios/modules/'+ filter.service + '.js'))().then(service => {
							const api = service.default.build()
							let params = ['']
							if (filter.serviceParams) params = [...filter.serviceParams]

							api[filter.method](...params).then(response => {
								let data = []
								/** Verifica se a requisição retornou uma paginação */
								if (Object.prototype.hasOwnProperty.call(response.data, 'total')) {
									data = [...response.data.data]

								/** Verifica se a requisição retornou um array */
								} else if (Object.prototype.hasOwnProperty.call(response.data, 'length')) {
									data = [...response.data]

								/** Se nenhum dos outros casos for atendido, trata o retorno como um objeto */
								} else if (typeof response.data === 'object') {
									if (response.data.data) {
										data = [...response.data.data]

									} else {
										data = { ...response.data }
									}
								}

								/** Verifica se os resultados necessitam ser formatados */
								if (filter.parse) {
									filter.options = filter.parse(data)
									/**
									 * Seta todas as regras de ociosidades no Vuex para serem utilizadas
									 * pelo datatable
									 */
									if (filter.params.name === 'idle_color_v2') this.setIdleRules(data)

								} else {
									filter.options = Object.values(data)
								}
							})

							filter.alreadyRequested = true
						})
					}
				}
			},
			/**
			 * Carrega os dados a serem mostrados na tabela de acordo com as configurações
			 * de paginação e filtragem
			 */
			loadData() {
				this.loading.load = true
				let params = null

				// Processa os filtros de acordo com o controle da listagem
				if (this.isCalledControl) {
					params = {
						page: this.pagination.page,
						per_page: this.pagination.per_page,
						complete: true
					}
					// Verifica se a string buscada é um CPF válido
					const searchType = this.$mx_validateCPF(this.search.value) ? 'cpf' : 'cod'
					params[searchType] = this.search.value

					// Processa os filtros de modo a enviá-los como parâmetros na listagem
					for (const filter of this.filters) {
						if (filter.params.value) {
							let value = filter.params.value
							/**
							 * Caso o valor do filtro seja um array, converte este em uma String
							 * antes de atribuir aos parâmetros de busca
							 */
							if (value && typeof value === 'object' &&
								Object.prototype.hasOwnProperty.call(value, 'length')) {
								value = value.join(',') || ''
							}

							params[filter.params.name] = value

						} else {
							continue
						}
					}

				} else {
					params = {
						page: this.pagination.page,
						perPage: this.pagination.per_page,
						search: this.search.value,
						filter: Object.values(this.filters).map(filter => filter.params)
					}
				}

				this.tableData = []
				let request = null
				// Verifica qual o controle da listagem de modo a utilizar a rota adequada
				if (this.isCalledControl) {
					request = launchDay.getAll(`deal/${this.definitions.launchday.id}`, params)

				} else {
					request = deal.dataTable(params)
				}

				request.then(response => {
						this.tableData = [...response.data.data]
						this.total = response.data.total || response.data.recordsFiltered
						this.pagination.total_pages = Math.ceil(this.total / this.pagination.per_page)
					})
					.catch(error => {
						this.total = 0
						this.pagination.page = 1
						this.pagination.total_pages = 0
						console.log(error)
					})
					.finally(() => {
						this.loading.load = false
						this.$store.dispatch('dataTable/setTotal', this.total)
					})
			},
            /**
             * Verifica se a página é aquela selecionada para paginação
             */
            isActivePage(page) {
                return this.pagination.page === page
            },
            /**
             * Event handler que trata o evento de quando uma página é selecionada diretamente
             * pela lista de páginas
             */
            listPageHandler(value) {
                switch (value) {
                    case 'right':
                        this.pagination.list_index++
                        break

                    case 'left':
                        this.pagination.list_index--
                        break

                    default:
                        this.setPage(value)
                        break
                }
            },
            /**
             * Seta a página a ser buscada e realiza a requisição
             */
            setPage(page) {
                if (page > 0 && page <= this.pagination.total_pages) {
					this.pagination.page = page
                    this.$set(this.pagination, 'page', page)

                } else if (page <= 0) {
					this.pagination.page = 1

                } else {
					this.pagination.page = this.pagination.total_pages
                }
                this.loadData()
            },
			/**
			 * Handler function que trata o evento de quando uma nova página de dados é
			 * requisitada
			 */
			nextPageHandler() {
                let page = this.pagination.page + 1
                this.setPage(page)
            },
			/**
			 * Handler function que trata o evento de quando a página anterior de dados
			 * é requisitada
			 */
            previousPageHandler() {
                let page = this.pagination.page - 1
                this.setPage(page)
            },
			/**
			 * Trata o evento de quando a chamada do próximo cliente é requisitada
			 */
			callCustomer() {
				/**
				 * author: Álefe Macedo
				 * O envio dos parâmetros de paginação foi um requerimento do Backend. Todavia, no
				 * futuro será revista a necessidade destes parâmetros, pois não fazem sentido no
				 * ponto de vista das boas práticas.
				 */
				this.loading.call = true
				launchDay.get('next-call', this.definitions.launchday.id, { per_page: 1, page: 1 })
					.then(response => {
						const deal =  { ...response.data }
						this.$root.$emit('modal-open-call-customer', deal)
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.log(error)
					})
					.finally(() => {
						this.loading.call = false
					})
			},
			/**
			 * Handler para tratar o evento de quando uma etapa for selecionada, de modo
			 * a carregar os status desta etapa
			 */
			funnelStageHandler(value) {
				const index = this.filters.findIndex(filter => filter.params.name === 'funnel_stage_status_id')
				this.filters[index].options = []
				this.filters[index].params.value = []
				this.filters[index].disabled = true

				if (value) {
					this.filters[index].loading = true
					funnel.getStatusByStage(value)
						.then(response => {
							this.filters[index].options = [...response.data]
							this.filters[index].disabled = false
						})
						.catch(error => {
							if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						})
						.finally(() => {
							this.filters[index].loading = false
						})
				}
			},
			/**
			 * Handler para tratar o evento de quando uma equipe for selecionada, de modo
			 * a carregar os gerentes desta equipe
			 */
			teamHandler(value) {
				const manager = this.filters.findIndex(filter => filter.params.name === 'manager_id')
				this.filters[manager].options = []
				this.filters[manager].params.value = null
				this.filters[manager].disabled = true

				const broker = this.filters.findIndex(filter => filter.params.name === 'broker_id')
				this.filters[broker].options = []
				this.filters[broker].params.value = null
				this.filters[broker].disabled = true

				/** Check if the event value is valid */
				const isValid = value && (typeof value === 'object' ? value.length : true)

				if (isValid) {
					this.filters[manager].loading = true
					team.getManagersByTeam(value)
						.then(response => {
							this.filters[manager].options = response.data
							this.filters[manager].disabled = false
							if (this.user.user_group === 'manager') {
								this.call(this.filters[manager].handler, this.filters[manager].params.value)
							}
						})
						.catch(error => {
							if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						})
						.finally(() => {
							this.filters[manager].loading = false
						})
				}
			},
			/**
			 * Handler para tratar o evento de quando um gerente for selecionado, de modo
			 * a carregar os corretores pelos quais este é responsável
			 */
			managerHandler(value) {
				const index = this.filters.findIndex(filter => filter.params.name === 'broker_id')
				this.filters[index].options = []
				this.filters[index].params.value = null
				this.filters[index].disabled = true

				// Verifica se o valor do evento é válido
				const isValid = value && (typeof value === 'object' ? value.length : true)

				if (isValid) {
					this.filters[index].loading = true
					team.getBrokersByManager(value)
						.then(response => {
							this.filters[index].options = response.data
							this.filters[index].disabled = false
						})
						.catch(error => {
							if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						})
						.finally(() => {
							this.filters[index].loading = false
						})
				}
			},
			/**
			 * Handler para tratar o evento de quando uma quadra é selecionada e deseja-se listar as
			 * unidades/lotes
			 */
			blockHandler(value) {
				const index = this.filters.findIndex(filter => filter.params.name === 'unit_id')
				this.filters[index].options = []
				this.filters[index].params.value = null
				this.filters[index].disabled = true

				/** Check if the event value is valid */
				const isValid = !!value

				if (isValid) {
					this.filters[index].loading = true
					availability.getBlockUnits(this.definitions.product.availability_id, value)
						.then(response => {
							this.filters[index].options = response.data
							this.filters[index].disabled = false
						})
						.catch(error => {
							if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						})
						.finally(() => {
							this.filters[index].loading = false
						})
				}
			},
            /**
             * Event handler que trata o evento de abrir a lista de chamada em uma nova aba
             */
            callListHandler() {
                const route = this.$router.resolve({ name: 'launch.control.customer_call' })
				window.open(route.href, '_blank')
            },
			/**
			 * Reseta os filtros
			 */
			resetFilters() {
				for (const filter of this.filters) {
					if (filter.component === 'select-tags') {
						filter.params.value = null
						if (filter.handler) this.call(filter.handler, null)
					}
				}
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
